module.exports = __webpack_public_path__ + "media/src/videos/hero-video-60e13839dcf7aa155a10e33f2404c8ae.mp4";